// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'


export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    user: null
  },
  reducers: {
    handleLogin: (state, action) => {
      state.user = action.payload
      localStorage.setItem('userData', JSON.stringify(action.payload))
    },
    handleLogout: state => {
      state.user = {}
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      window.location.reload(true)
    },
    handleRegister: (state, action) => {
      state.user = action.payload
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.setItem('userData', JSON.stringify(action.payload))
    }
  }
})

export const { handleLogin, handleLogout, handleRegister } = authSlice.actions

export default authSlice.reducer